var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-resize-observer", { on: { resize: _vm.handleResize } }, [
    _c("div", { attrs: { "data-component": "base-tabs" } }, [
      _c(
        "div",
        { ref: "tabs", staticClass: "tabs" },
        [
          _c(
            "div",
            { staticClass: "tabs-left" },
            _vm._l(_vm.visibleItems, function (ref) {
              var value = ref.value
              var label = ref.label
              return _c(
                "a",
                {
                  key: value,
                  class: {
                    active: _vm.activeTabId === value,
                    "active-only": _vm.onlyActiveItem,
                  },
                  attrs: { "data-tab": value },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectTab(value)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("\n            " + _vm._s(label) + "\n          "),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.menuItems.length
            ? _c("or-icon-button", {
                ref: "button",
                attrs: { "data-menu-trigger": "", icon: "more_horiz" },
                on: {
                  click: function ($event) {
                    _vm.isMenuOpen = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLayoutMobile && _vm.isMenuOpen
            ? _c("base-tabs-mobile-popup", {
                attrs: {
                  "menu-items": _vm.menuItems,
                  "active-item-id": _vm.activeTabId,
                  "data-base-tabs-popup": "",
                },
                on: {
                  "item-click": function ($event) {
                    return _vm.selectTab($event)
                  },
                  "close-click": function ($event) {
                    _vm.isMenuOpen = false
                  },
                },
              })
            : _vm.isMenuOpen
            ? _c(
                "or-menu",
                {
                  attrs: {
                    trigger: _vm.buttonRoot,
                    "is-open": _vm.isMenuOpen,
                    "data-base-tabs-menu": "",
                  },
                  on: {
                    open: function ($event) {
                      _vm.isMenuOpen = true
                    },
                    close: function ($event) {
                      _vm.isMenuOpen = false
                    },
                  },
                },
                _vm._l(_vm.menuItems, function (ref) {
                  var value = ref.value
                  var label = ref.label
                  return _c(
                    "or-menu-item",
                    {
                      key: value,
                      class: { active: _vm.activeTabId === value },
                      attrs: { "data-menu-item": value },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.selectTab(value)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(label) + "\n        ")]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [_vm._t("content", null, { item: _vm.activeItem })],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }